/******************************************************************************
*
* Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
*
* Unauthorized copying of the code in this file, completely or partially,
* via any medium is strictly prohibited.
*
* Proprietary and Confidential.
*
* Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, June 2022
*
*****************************************************************************/

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
